{
	"name": "pandora-web",
	"version": "1.6.2",
	"scripts": {
		"ng": "ng",
		"start": "ng serve",
		"start:fresh": "node -e \"require('fs').rmSync('.angular',{recursive:true,force:true})\" && ng serve",
		"start:lib-dev": "ng serve --prebundle=false",
		"build": "ng build",
		"build:prod": "ng build --configuration=production --cross-origin=use-credentials",
		"lint": "ng lint",
		"source-map-analyzer": "ng build --configuration=production --source-map",
		"source-map-explorer": "source-map-explorer dist/pandora-web/**/*.js",
		"sentry:sourcemaps": "sentry-cli sourcemaps inject --org its-future --project feelink-web ./dist && sentry-cli sourcemaps upload --org its-future --project feelink-web ./dist"
	},
	"private": true,
	"overrides": {
		"reflect-metadata": "0.1.13"
	},
	"dependencies": {
		"@211-feelink/gojsgraph": "^0.0.5",
		"@211-feelink/litegraph": "^0.5.1",
		"@angular/cdk": "^22.0.6",
		"@angular/common": "^22.0.8",
		"@angular/compiler": "^22.0.8",
		"@angular/core": "^22.0.8",
		"@angular/forms": "^22.0.8",
		"@angular/material": "^22.0.6",
		"@angular/material-luxon-adapter": "^22.0.6",
		"@angular/platform-browser": "^22.0.8",
		"@angular/router": "^22.0.8",
		"@jsverse/transloco": "^8.4.0",
		"@microsoft/fetch-event-source": "^2.0.1",
		"@sentry/angular": "^10.67.0",
		"@sentry/cli": "^3.6.2",
		"@types/luxon": "^3.7.2",
		"angular-auth-oidc-client": "21.0.2",
		"bootstrap": "^5.3.8",
		"broadcast-channel": "^7.3.0",
		"core-js": "^3.49.0",
		"exceljs": "^4.4.0",
		"gojs": "^4.0.3",
		"gojs-angular": "^20.0.0",
		"lodash-es": "^4.18.1",
		"luxon": "^3.7.2",
		"ngx-quill": "^31.0.1",
		"quill": "^2.0.3",
		"rxjs": "~7.8.2",
		"tslib": "^2.8.1",
		"zone.js": "~0.16.2"
	},
	"devDependencies": {
		"@angular/build": "^22.0.7",
		"@angular/cli": "^22.0.7",
		"@angular/compiler-cli": "^22.0.8",
		"@angular/language-service": "^22.0.8",
		"@eslint/js": "^10.0.1",
		"@trivago/prettier-plugin-sort-imports": "^6.0.2",
		"@types/lodash-es": "^4.17.12",
		"@types/node": "^26.1.1",
		"angular-eslint": "22.1.0",
		"eslint": "^10.7.0",
		"eslint-config-prettier": "^10.1.8",
		"eslint-plugin-jsdoc": "^63.2.0",
		"eslint-plugin-prefer-arrow": "^1.2.3",
		"prettier": "^3.9.6",
		"prettier-plugin-organize-attributes": "^1.0.0",
		"source-map-explorer": "^2.5.3",
		"ts-node": "~10.9.2",
		"typescript": "~6.0.3",
		"typescript-eslint": "8.65.0"
	}
}
